import { SipActionFilter } from '../../api/types'

const SIP_FILTER_EMPTY_STATE_ILLUSTRATION_SRC = '/images/allocation/plans-filter-empty-state.png'
export const PLANS_FILTER_EMPTY_STATE_SELECTOR = '[data-plans-filter-empty-state]'

function getSipActionFilterEmptyMessage(actionFilter: SipActionFilter): string {
  if (actionFilter === SipActionFilter.STOP) {
    return 'No funds to stop'
  }
  if (actionFilter === SipActionFilter.START) {
    return 'No funds to start'
  }
  return 'No funds'
}

type SipPlansListFilterEmptyStateProps = {
  actionFilter: SipActionFilter
}

export function SipPlansListFilterEmptyState({ actionFilter }: SipPlansListFilterEmptyStateProps) {
  return (
    <div
      data-plans-filter-empty-state
      className="bg-white px-5 pt-6 pb-12 h-[400px] flex items-center justify-center"
    >
      <div className="flex flex-col items-center">
        <img
          src={SIP_FILTER_EMPTY_STATE_ILLUSTRATION_SRC}
          alt=""
          className="mb-[-20px] h-[184px] w-[243px] object-contain"
        />
        <p className="max-w-[173px] text-center text-[13px] font-[400] leading-[150%] text-[#8E9393]">
          {getSipActionFilterEmptyMessage(actionFilter)}
        </p>
      </div>
    </div>
  )
}
